import _regeneratorRuntime from "/workspace/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/workspace/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/node_modules/@babel/runtime/helpers/esm/createClass";
import { resolveArtifact } from '../utils/metadata';
import Permission from './Permission';

var Role =
/*#__PURE__*/
function () {
  function Role(data, metadata, organization) {
    _classCallCheck(this, Role);

    var _a;

    var roles = metadata[0].roles;
    var role = roles === null || roles === void 0 ? void 0 : roles.find(function (role) {
      return role.bytes === data.hash;
    });
    this.appAddress = data.appAddress;
    this.description = role === null || role === void 0 ? void 0 : role.name;
    this.hash = data.hash;
    this.manager = data.manager;
    this.name = role === null || role === void 0 ? void 0 : role.id;
    this.params = role === null || role === void 0 ? void 0 : role.params;
    this.permissions = (_a = data.grantees) === null || _a === void 0 ? void 0 : _a.map(function (grantee) {
      return new Permission(grantee, organization);
    });
  }

  _createClass(Role, null, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(data, organization) {
        var artifact, metadata;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return resolveArtifact(data);

              case 2:
                artifact = _context.sent;
                metadata = [artifact];
                return _context.abrupt("return", new Role(data, metadata, organization));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function create(_x, _x2) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }]);

  return Role;
}();

export { Role as default };